import { Outlet } from 'react-router-dom'
import { useState, useEffect, FC } from 'react'
import useRefreshToken from '../../hooks/useRefreshToken'
import { useAuth } from '../../context/AuthProvider'
import Loading from "../Loading/Loading"
import DashboardLayout from '../../layouts'

const PersistLogin: FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const refresh = useRefreshToken()
  const { auth } = useAuth()

   // const effectRan = useRef<boolean>(false) //useRef is used to persist the value of a variable across renders without triggering a re-render when the value changes

  useEffect(() => {
    let isMounted = true

    // if (effectRan.current === true || process.env.NODE_ENV !== 'development') {  // Uncomment this line when enabling React.StrictMode
      const verifyRefreshToken = async () => {
        try {
          await refresh()
        } catch (err: any) {
          if (err?.code !== 'NO_ACTIVE_MSAL_ACCOUNT' && !err?.silent) {
            console.error(err)
          }
        } finally {
          isMounted && setIsLoading(false)
        }
      }

      !auth?.user && !auth?.platformAdmin ? verifyRefreshToken() : setIsLoading(false)
    // }

    return () => {
      isMounted = false
      // effectRan.current = true
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return isLoading ? (
    <Loading />
  ) : (
    <>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </>
  )
}

export default PersistLogin
